export const ENABLE_RESPONSE_MAX_TOKENS = false;

/**
 * Generic fallback default identifiers used when persona-specific voice or
 * Tavus configuration is omitted.
 */
export const DEFAULT_ELEVENLABS_VOICE_ID = 'D7xl8UR5QXybVKzsVpdi';
export const DEFAULT_TAVUS_CONVERSATIONS_ENDPOINT = '/conversations';
export const DEFAULT_TAVUS_REPLICA_ID = 'red1aaf7d688';
